<template>
    <div class="titleMore"> 
        <div class="title">
            {{ title }}
        </div>
        <div class="more" @click="moreHandler">
            {{ $t('ViewAll') }}
            <img src="../assets/img/newmore@2x.png" class="moreico" />
        </div>
    </div>
</template>
<script>
export default{
    name:'TitleMore',
    props:{
        title:{
            type:[String],
            default:'热点新闻'
        },
        code:{
            type:[String],
            default:'NEWS'
        },
        toPath:{
            type:[String],
            default:''
        }
    },
    data(){
        return {

        }
    },
    methods:{
        async moreHandler(){
            // 处理code
            var codeObj = await this.filterMenuCode(this.code)
            var code = codeObj[this.title]
            if(this.toPath && this.toPath.length) {
                this.$router.push({
                    path: this.toPath+'?code='+code
                })
            }
        }
    }
}
</script>
<style lang="scss">
.titleMore{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .title{
        font-weight: bold;
        font-size: 32px;
        color: #333333;
    }
    .more{
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        .moreico{
            margin-left: 10px;
            width: 9px;
            height: 16px;
        }
    }
}
.titleMore:hover{
    .title{
        color: #004098;
    }
    .more{
        color: #004098;
    }
}
</style>